// LocalStorage keys constants
export const LOCAL_STORAGE_KEYS = {
  // Theme related
  THEME: 'bs-theme',
  THEME_DO_NOT_SHOW: 'bs-theme-do-not-show',
  
  // Internationalization
  ID_LOCALE: 'bs-idLocale',
  ID_LANGUAGE: 'bs-idLanguage',
  LANGUAGE_SWITCHER_DO_NOT_SHOW: 'bs-language-switcher-do-not-show',
  
  // Authentication
  AUTH_MODE: 'authMode',
  
  // WebSocket
  WS_SESSION: 'wsSession',
  
  // App state
  LAST_TIME_BUILD: 'last-time-build',
  SELECTED_TIMEFRAME: 'selectedTimeframe',
  SELECTED_CANDLE_COUNT: 'selectedCandleCount',
} as const

// Type for localStorage keys
export type LocalStorageKey = typeof LOCAL_STORAGE_KEYS[keyof typeof LOCAL_STORAGE_KEYS]

// Helper function to get localStorage value with type safety
export const getLocalStorageValue = (key: LocalStorageKey): string | null => {
  return localStorage.getItem(key)
}

// Helper function to set localStorage value
export const setLocalStorageValue = (key: LocalStorageKey, value: string): void => {
  localStorage.setItem(key, value)
}

// Helper function to remove localStorage value
export const removeLocalStorageValue = (key: LocalStorageKey): void => {
  localStorage.removeItem(key)
} 